export default {
  invoice_applu_tips_remark:
    'When the invoice amount is less than 1000 RMB, our company only issues "Ordinary electronic invoice" and does not provide "special VAT invoice".',
  invoice_applu_tips_title:
    "Please check the order you need and then selection of Invoice Type",
  invoice_apply_time: "The invoice application time is:",
  status_enumerate_canceled: "canceled",
  status_enumerate_passed: "already passed",
  status_enumerate_merged: "Has been merged",
  status_enumerate_cancel: "Has been derived",
  status_enumerate_refuse: "refuse ",
  status_enumerate_checked: "checked",
  status_enumerate_checking: "in review",
  status_enumerate_waitcheck: "To audit",
  mes_totals_nullbool: "Please check the item you want to invoice",
  mes_code_successbool:
    "Please enter the correct remittance identification code!",
  mes_cancel_error: "Cancel the failure!",
  mes_cancel_success: "Cancel the success!",
  mes_view_inner: "Are you sure you want to cancel the invoice application",
  mes_view_title: "reminder",
  mes_no_code: "The remittance identification code cannot be empty",
  mes_disable: "The amount is under application for invoice or refund",
  deduction_fee_header_shows_that: "deduction shows that",
  deduction_fee_header_detail: "deduction detail",
  invoice_history_header_operation: "operation",
  invoice_history_header_status: "Approval Status",
  invoice_history_header_remarks: "remarks",
  invoice_history_header_reason: "opinion",
  invoice_history_header_money: "money",
  invoice_history_header_createDate: "time of application",
  invoice_history_header_invoice_title: "invoice title",
  invoice_history_header_applicatenum: "application number",
  invoice_list_header_subtotal: "subtotal",
  invoice_list_header_refund_amount: "refund amount",
  invoice_list_header_number: "number",
  invoice_list_header_applied_amount: "applied amount",
  invoice_list_header_specification: "specification",
  invoice_list_header_goodsName: "goodsName",
  info_invoice_tracking_number: "Tracking Num",
  info_invoice_relation_phone: "Phone",
  info_invoice_consignee_address: "ConsigneeAddr",
  info_invoice_recipients: "Recipient",
  info_invoice_status: "Status",
  info_invoice_companyPhone: "Company Tel",
  info_invoice_registeredaddress: "Company Addr",
  info_invoice_bankacount: "Bank Account",
  info_invoice_accountname: "Bank",
  info_invoice_mergeMoney: "Merge Money",
  info_invoice_applyMoney: "Apply Money",
  info_invoice_applyUser: "Apply User",
  info_invoice_applyNumber: "Apply Number",
  info_invoice_type_text2: "value added tax invoice",
  info_invoice_type_text1: "general invoice",
  info_invoice_type: "Invoice Type",
  info_invoice_title: "Invoice Title",
  info_taxcode: "Taxpayer Code",
  info_file_title: "Invoice Attachment Information",
  info_order_title: "Invoice Application Order Details",
  info_post_title: "Mail Receipt Information",
  info_invoice_header: "Invoice Request Header Information",
  clone_btn: "close",
  info_title: "Invoice Details",
  list_cancel_btn: "cancel",
  list_edit_btn: "edit",
  list_look_btn: "details",
  invoiceInfoLineHeader_title: "goodsName",
  tabsThree: "fee deduction",
  tabsTwo: "record",
  tabsOne: "apply for",
  cost_item_hint: "The amount is under application for invoice or refund",
  appy_time: "Time",
  booth_number: "Booth Number",
  payment_code: "Payment code",
  especially_invoice_btn: "value added tax invoice ",
  general_invoice_btn: "general invoice",
  tital_text: "Total invoice amount:",
  load_more: "LoadMore...",
  search: "search",
  reset: "reset",
  remitCode_input_placeholder:
    "Please enter the remittance identification number",
  remitCode_placeholder:
    'Multiple identification codes can be input successively and click "+" to add and then search',
  remitCode: "RemittanceCode",
  exhibitionName: "Exhibition",
  explainCode:
    "If you pay by cash/credit card on site, please check the remittance identification number",
  explainCode_text:
    "The fees paid on site will be located below the bar code in the receipt we gave you, as shown in the red box in the picture:",
  order_number: "order number",
  发票需要到: "Invoices need",
  未到发票申请时间: "The invoice application time has not arrived",
  之后才可以申请: "before they can be applied for",
  请输入想要查询的展位名: "Please enter the booth name you want to query",
  展位号不存在: "No booth number exists",
  的展位: "was found",
  提示: "tips",
  当前已选择开票金额: "Currently selected invoice amount",
  元: "RMB",
  下一步: "Next",
  以下订单为现场缴费订单:
    "The following orders are on-site payment orders. You need to fill in the remittance identification number to apply for the invoice.",
  选择展位号: "Selection of booth number",
  查询展位号: "Search booth number",
  当前展位无订单: "No orders for the current exhibition",
  您还没有选择展位:
    "You have not selected the booth yet. Please select the booth first or enter the booth number directly for inquiry.",
  请输入展位号: "Please enter booth number",
  您还有未确认的现场订单:
    "Do you have an unconfirmed on-site order, reconfirmed or not?",
  提示: "tips",
  该展位号已存在: "The booth number already exists.",
  发票状态: "Invoice status",
  返回: "Back",
  "您的发票明细里面的订单正在进行退款，暂不能修改发票信息":
    "The order in your invoice details is being refunded, and the invoice information cannot be modified temporarily",

  WAITCHECK: "To audit",
  CHECKING: "In review",
  CHECHED: "checked",
  REFUSE: "refuse",
  CANCEL: "Has been derived",
  MERGE: "Has been merged",
  PASS: "already passed",
  CANCELED: "canceled",

  PUPIAO: "invoice",
  ZHUANPIAO: "VAT invoice",

  下载发票: "Download"
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/invoice.js